import TableSkeleton from './table-skeleton';

export default function SoldeCarteTableSkeleton() {
    const columns = ['Numéro', 'Type', 'Porteur', 'Produit', 'Solde'];

    return <TableSkeleton rows={5} columns={columns} />;
}
